import { render, staticRenderFns } from "./editPage.vue?vue&type=template&id=a7972766&scoped=true&"
import script from "./editPage.vue?vue&type=script&lang=js&"
export * from "./editPage.vue?vue&type=script&lang=js&"
import style0 from "./editPage.vue?vue&type=style&index=0&id=a7972766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7972766",
  null
  
)

export default component.exports